// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import VaticanCity from '../_raw/flag/icon_flag_vatican_city.png';

export default () => <img src={VaticanCity} alt="VaticanCity" />;
